import headerImg from "assets/images/v143/header.webp"
import ratingImg from "assets/images/v143/rating.webp"
import previewImg from "assets/images/v143/preview.webp"
import reviewsImg from "assets/images/v143/reviews.webp"

export const v143Config = {
  title: {
    en: headerImg,
  },
  rating: {
    en: ratingImg,
  },
  preview: {
    en: previewImg,
  },
  reviews: {
    en: reviewsImg,
  },
}
